import { render, staticRenderFns } from "./eliza.vue?vue&type=template&id=b1e1ade6&"
import script from "./eliza.vue?vue&type=script&lang=js&"
export * from "./eliza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\gw-actions-runner\\_work\\gower-web-core\\gower-web-core\\App.Core.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1e1ade6')) {
      api.createRecord('b1e1ade6', component.options)
    } else {
      api.reload('b1e1ade6', component.options)
    }
    module.hot.accept("./eliza.vue?vue&type=template&id=b1e1ade6&", function () {
      api.rerender('b1e1ade6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/components/generic/eliza.vue"
export default component.exports